import React from "react";
import { AppBar, Box, Card, CardActionArea, Dialog, Divider, IconButton, Slide, Toolbar, Typography } from "@mui/material";
import { TransitionProps } from "notistack";
import CloseIcon from '@mui/icons-material/Close';

import BookmarkDispatch from "./model";
import BookmarkState from "../../State/BookmarkState";
import styled from "@emotion/styled";
import { loadBookmark } from "../../../../../../../local/storage";
import { VirtuosoGrid } from "react-virtuoso";
import AutoSizer from "react-virtualized-auto-sizer";
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ItemContainer = styled.div`
  padding: 0.5rem;
  width: 100%;
  display: flex;
  flex: none;
  align-content: stretch;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    width: 100%;
  }

  @media (max-width: 300px) {
    width: 100%;
  }
`

const ItemWrapper = styled.div`
  flex: 1;
  text-align: center;
  font-size: 80%;
  padding: 1rem 1rem;
  border: 1px solid var(gray);
  white-space: nowrap;
`

const ListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`

class Bookmark extends React.PureComponent<{}>{

    render() {
        let dispatcher: BookmarkDispatch = (this.props as any).dispatcher
        let state: BookmarkState = (this.props as any).state

        let html: JSX.Element

        let list = loadBookmark()
        
        if (list.length === 0) {
            html = <Box sx={{ flexGrow: 1, flexDirection: 'column', mt: 5 }} display="flex"
                justifyContent="center"
                alignItems="center">
                <Typography variant="subtitle1" sx={{ mr: 1, ml: 1 }} color='error'>
                    اطلاعات یافت نشد
                </Typography>
            </Box>
        } else {

            html = <Box sx={{ pr: 1, pl: 1, pt: 2, pb: 2, height: '100%' , width : '100%' }}>
                <VirtuosoGrid /*className='none-scrollbar'*/ components={{
                    Item: ItemContainer,
                    List: ListContainer as any,
                    ScrollSeekPlaceholder: ({ height, width, index }) => (
                        <ItemContainer>
                            <ItemWrapper>{'--'}</ItemWrapper>
                        </ItemContainer>
                    ),
                }} totalCount={list.length} itemContent={(index, data, context) => {
                    let value = list[index]

                    return <Card key={index} variant="elevation" sx={{ width: '100%', height: '400px', borderRadius: '12px', borderColor: 'transparent' }} >
                        <CardActionArea sx={{ width: '100%', height: '100%', flexDirection: 'column' }} onClick={() => {
                               dispatcher.onItemClicked(value)
                        }}>

                            <AutoSizer disableHeight style={{ width: '100%' }}>
                                {({ width }: any) => {
                                    return (
                                        <Box sx={{
                                            height: '300px',
                                            width: width
                                        }} >
                                            <Box
                                                component="img"
                                                sx={{
                                                    height: '300px',
                                                    width: width,
                                                    objectFit: 'cover'
                                                }}
                                                alt='vilage'
                                                src={value.picPath + value.pics[0]}
                                                crossOrigin='anonymous'
                                            />

                                            <Box sx={{
                                                position: 'absolute',
                                                top: 0,
                                                right: 0, m: 1
                                            }}><Card variant="outlined" sx={{ pr: 1, pl: 1, borderRadius: '24px', borderColor: 'transparent' }} >

                                                    <Typography variant="caption" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary' textAlign='center'>
                                                        {new Date(value.updateAt).ago()}
                                                    </Typography>
                                                </Card></Box>
                                        </Box>
                                    )
                                }
                                }
                            </AutoSizer>




                            <Box sx={{ width: '100%', flexDirection: 'row', mt: 2 }} display='flex'>

                                <Box sx={{ flexGrow: 0.25, flexDirection: 'column', pr: 1, pl: 1 }} display='flex' justifyContent="center" alignItems="center">
                                    <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                        نوع
                                    </Typography>
                                    <Divider orientation="horizontal" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />
                                    <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                        {(value.fileType as any).title}
                                    </Typography>
                                </Box>
                                {
                                    value.props.map((val, index, arr) => {
                                        return (
                                            <Box key={val.value + val.title + index} sx={{ flexGrow: 0.25, flexDirection: 'column', pr: 1, pl: 1 }} display='flex' justifyContent="center" alignItems="center">
                                                <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                                    {val.title}
                                                </Typography>
                                                <Divider orientation="horizontal" variant="middle" flexItem sx={{ ml: 1, mr: 1 }} />
                                                <Typography variant="subtitle2" display="block" gutterBottom sx={{ mr: 1, ml: 1 }} color='primary'>
                                                    {val.valueType === 'price' ? val.value.toWordPrice() : `${val.value}`}
                                                </Typography>
                                            </Box>
                                        )
                                    })
                                }

                            </Box>
                        </CardActionArea>

                    </Card>

                }} />
            </Box>
        }

        return (
            <Dialog
                fullScreen
                open={state.show}
                dir="rtl"
                TransitionComponent={Transition} >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={() => {
                                dispatcher.show()
                            }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ mr: 2, fontFamily: 'font-farsi-logo' }}>
                            ویـــلاگــــرام
                        </Typography>
                        <Typography variant="subtitle1" component="div" sx={{ flexGrow: 1, mr: 2 }} textAlign='start'>
                            : ذخیره شده ها
                        </Typography>

                    </Toolbar>
                </AppBar>

                <Box sx={{ width: '100%', height: '100%', flexDirection: 'row' }} display='flex'>
                    {html}
                </Box>
            </Dialog >
        )
    }

}

export default Bookmark

